<script>
	import Gallery from '../States/Gallery';
	import Helper from '../Models/Helper';

	let active = false;
	let list = [];

	function uri(group, item) {
		item = Helper.zeroPad(item, 3);
		const path = `${group.path}/mop${group.number}x${item}.jpg`;
		return path;
	}

	function generateList(api, group) {
		const content = [];
		for (let index = 1; index <= group.count; index++) {
			const thing = uri(group, index);
			const item = {uri: thing, large: false};
			content.push(item);
		}

		list = content;
	}

	function back() {
		$Gallery.view = 'category';
		$Gallery.group = {};
	}

	function galleryChange(gallery) {
		active = Helper.is(gallery.api) && (gallery.view == 'group');
		if (active) {
			window.scrollTo({top: 0});
			generateList(gallery.api, gallery.group);
		}
	}

	Gallery.subscribe(gallery => galleryChange(gallery));
</script>

<style>
	div.group {
		display: none;
	}

	div.group.active {
		display: block;
	}

	div.list {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		margin-bottom: 3em;
	}

	div.list > div {
		width: 50%;
		height: 17em;
		background: #000;
	}

	div.list > div > img {
		object-fit: contain;
		object-position: center center;
		width: 100%;
		height: 100%;
	}

	div.list > div > img.large {
		position: fixed;
		top: 0; right: 0; bottom: 0; left: 0;
	}

	button {
		display: block;
		color: #888;
		font-weight: bold;
		background: #000;
		text-align: center;
		border: 1px solid #222;
		padding: 2em 1em;
		width: 100%;
	}
</style>

<div class="group" class:active="{active}">
	<div class="list">
		{#each list as item}
			<div class="item" on:click="{event => { item.large = !item.large }}">
				<img src="{item.uri}" class:large="{item.large}"/>
			</div>
		{/each}
	</div>
	<button on:click="{event => back()}">Back</button>
</div>